/* app/js/src/components/live-sources/live-sources-grid/live-sources-grid.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.live-sources-grid {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.live-sources-grid__empty {
  text-align: center;
  padding: 48px 24px;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
}
/*# sourceMappingURL=live-sources-grid.component.css.map */
